
import { defineComponent } from "vue";
import { SkinProfileTextFields } from "@/controller/skin-profile";
import SkinProfileFormInput from "./SkinProfileFormInput.vue";
import NormalButton from "@/components/NormalButton.vue";
import IconButton from "@/components/IconButton.vue";

export default defineComponent({
  name: "SkinProfileForm",

  components: {
    SkinProfileFormInput,
    NormalButton,
    IconButton
  },

  data() {
    return {
      feeling: "",
      skinType: "",
      skinTime: "",
      sleep: "",
      note: "",
      file: null as null | File
    };
  },

  methods: {
    emitSave() {
      const skinProfile: SkinProfileTextFields = {
        feeling: this.feeling,
        skinType: this.skinType,
        skinTime: this.skinTime,
        sleep: this.sleep,
        note: this.note
      };
      this.$emit("save", skinProfile, this.file);
    },

    setTargetFile(event: Event) {
      const target = event.target as HTMLInputElement;
      const files = target.files as FileList;
      this.file = files[0];
    }
  }
});
